import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';

@Injectable()
export class ResponsePluginService extends InspectionPluginService {
  constructor(
    protected apiService: ApiService,
    protected dataService: DataService,
    private boxesFactory: InspectionFactoryService
  ) {
    super(apiService, dataService, null, boxesFactory);
  }

  public updateResponse(inspectionId: string, pointId: string, pluginId: string, config: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, config).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, value: any): Observable<any> {
    return this.boxesFactory.updatePluginConfig(inspectionId, pointId, pluginId, value).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
